import { render, staticRenderFns } from "./ResetEditor.vue?vue&type=template&id=3da95d48&scoped=true&"
import script from "./ResetEditor.vue?vue&type=script&lang=js&"
export * from "./ResetEditor.vue?vue&type=script&lang=js&"
import style0 from "./ResetEditor.vue?vue&type=style&index=0&id=3da95d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da95d48",
  null
  
)

export default component.exports